import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

import type { SkippedPaymentFinalDialogProps } from './SkippedPaymentFinalDialog.types';

export const openSkippedPaymentFinalModal = (data: SkippedPaymentFinalDialogProps) =>
    openPopupHelper({ popupName: popupNames.SKIPPED_PAYMENT_FINAL_MODAL, data });
